import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["background", "border", "heading", "content", "button", "additionalButton"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import Button from '../button/Button';
import Heading from '../heading/Heading';
import Box from '../layout/Box';
import Centered from '../layout/Centered';
import Container from '../layout/Container';
import Section from '../layout/Section';
import Text from '../text/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var BackgroundWrapper = styled(Box).attrs(function (props) {
  return {
    $pt: [32, 90, 90, 90],
    $pb: [64, 120, 120, 120],
    $px: 20,
    $styles: {
      borderRadius: 16,
      backgroundColor: props.$background,
      border: props.$border
    }
  };
}).withConfig({
  displayName: "CallToAction__BackgroundWrapper",
  componentId: "sc-bmr7v5-0"
})({});
var CtaHeading = styled(Heading).attrs({
  $variant: ['h3', 'h2', 'h2', 'h2'],
  $mx: 'auto',
  $align: 'center',
  $styles: {
    maxWidth: [null, 740, 740, 740]
  }
}).withConfig({
  displayName: "CallToAction__CtaHeading",
  componentId: "sc-bmr7v5-1"
})({});
var CtaText = styled(Text).attrs({
  $variant: 'p1',
  $align: 'center',
  $mt: 16,
  $mx: 'auto',
  $styles: {
    maxWidth: [null, 550, 550, 550],
    opacity: 'var(--wcds-legacy-paragraph-opacity)'
  }
}).withConfig({
  displayName: "CallToAction__CtaText",
  componentId: "sc-bmr7v5-2"
})({});
var CtaButton = styled(Button).attrs({
  $buttonType: 'primary',
  $size: 'medium',
  $withArrow: true,
  $mt: 40
}).withConfig({
  displayName: "CallToAction__CtaButton",
  componentId: "sc-bmr7v5-3"
})({});
var CtaAdditionalButton = styled(Button).attrs({
  $withArrow: true,
  $size: 'medium',
  $buttonType: 'dark',
  $ml: 8
}).withConfig({
  displayName: "CallToAction__CtaAdditionalButton",
  componentId: "sc-bmr7v5-4"
})(["display:inline-block;"]);

var CallToAction = function CallToAction(_ref) {
  var background = _ref.background,
      border = _ref.border,
      heading = _ref.heading,
      content = _ref.content,
      button = _ref.button,
      additionalButton = _ref.additionalButton,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Section, _objectSpread(_objectSpread({
    as: "section"
  }, props), {}, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(BackgroundWrapper, {
        $background: background,
        $border: border,
        children: /*#__PURE__*/_jsxs(Centered, {
          children: [heading && /*#__PURE__*/_jsx(CtaHeading, {
            children: heading
          }), content && /*#__PURE__*/_jsx(CtaText, {
            children: content
          }), button && /*#__PURE__*/_jsx(CtaButton, _objectSpread({}, button)), additionalButton && /*#__PURE__*/_jsx(CtaAdditionalButton, _objectSpread({}, additionalButton))]
        })
      })
    })
  }));
};

export default CallToAction;